// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"07b22ea4","796":"d12ed5c6"}[chunkId] + ".chunk.js";
};